/* eslint-disable space-before-function-paren */
declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
  }
}

export type GtmPayload = Record<string, unknown>

export function gtmSendEvent(
  eventCategory: string,
  eventPayload: GtmPayload,
  eventLabel: string | false = false,
  usesEcommerce = false
): void {
  if (!window?.dataLayer) {
    window.dataLayer = [];
  }
  if (usesEcommerce) {
    pushDataLayer({
      event: eventCategory,
      ...eventPayload,
    });
  } else {
    pushDataLayer({
      event: "customEvent",
      eventCategory,
      eventPayload,
      eventLabel,
    });
  }
}

function pushDataLayer(options: Record<string, unknown>): void {
  window.dataLayer.push(options);
}
